export default "__VITE_ASSET__DxyBgpbw__"